import React from 'react'
import './stdButton.scss'

const StdButton = ({handleClick, text, color, solid}) => {
  return (
    <button className='print-hidden' onClick={handleClick} style={solid ? {background: color} : {background: 'transparent', color: color, border: `1px solid ${color}`, margin: '1rem'}}>{text}</button>
  )
}

export default StdButton